import "./index.css";
import SvgComponent from "../../SVGComponent";
// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @param {Object} props
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {String} props.text - text of the button
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String} props.icon - Takes svg as an props
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {String} props.title - title/tooltip of the button
 * @param {String} props.imgColor - Takes svg color as an props
 * @returns {JSX.Element}
 */
const SecondaryAnimatedButton = ({
  handleFunction,
  isDisabled,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  icon,
  hoverOption,
  buttonRef,
  title,
  text,
  imgColor,
}) => {
  return (
    <div className="w-auto flex justify-end">
      <button
        title={title}
        ref={buttonRef ? buttonRef : null}
        type={"button"}
        onClick={(e) => {
          if (!isLoading) handleFunction(e);
        }}
        className={`flex overflow-hidden secondary-animated-buttonicon z-z-index-base relative justify-center items-center p-padding-sm h-icon-lg rounded-border-radius-md w-icon-lg cursor-${
          isDisabled
            ? "not-allowed opacity-light-opacity "
            : `pointer ${
                hoverOption === "white"
                  ? "global-hover-white"
                  : "global-hover-black"
              }`
        }`}
        style={{
          backgroundColor:
            isDisabled && disabledBgColor
              ? disabledBgColor.toString()
              : enabledBgColor.toString(),
        }}
      >
        <div className="w-full flex flex-row items-center gap-gap-sm">
          <SvgComponent
            color={imgColor}
            height="var(--icon-xs)"
            width="var(--icon-xs)"
            url={icon}
            alt="Icon"
          />
          <p className="secondary-animated-buttontext truncate w-full font-normal text-text-primary text-font-sm">
            {text}
          </p>
        </div>
      </button>
    </div>
  );
};

export default SecondaryAnimatedButton;
